import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';
import DashboardContainer from '../DashboardContainer';
import PreviewComponent from './PreviewComponent';

const SettingsRoutes = lazy(() => loadingChunkRetry(() => import('./SettingsRoutes')));

const SettingsContainer = () => {
  return (
    <DashboardContainer showSecondaryNav>
      <ErrorBoundary>
        <Suspense fallback={<PreviewComponent />}>
          <SettingsRoutes />
        </Suspense>
      </ErrorBoundary>
    </DashboardContainer>
  );
};

export default SettingsContainer;
